import React, { useEffect, useRef, useState } from 'react';
import { Icons, IconsVariants, Spinner, SpinnerVariants } from '../../../UI';
import { DialogComponent } from '../../../components/DialogComponent/DialogComponent.tsx';
import { useUploadUserImageMutation } from '../../../apis';
import { imageSrc as buildImageSrc } from '../../../utils/imageUrl';

interface HeaderImageProps {
  imageUrl?: string;
  userId?: string;
  currentUserId: string | null;
}

export const HeaderImage: React.FC<HeaderImageProps> = ({ imageUrl, userId, currentUserId }) => {
  const [uploadUserImage, { isLoading }] = useUploadUserImageMutation();

  const [file, setFile] = useState<File | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [imgSrc, setImgSrc] = useState(imageUrl ? buildImageSrc(imageUrl, 'md') : '/cover.jpg');

  // Sync when the prop changes (viewing a different profile, or fresh data after refetch).
  useEffect(() => {
    setImgSrc(imageUrl ? buildImageSrc(imageUrl, 'md') : '/cover.jpg');
  }, [imageUrl]);

  const changeImgHandler = () => {
    inputRef.current?.click();
  };
  
  useEffect(() => {
    if (!file) return;

    (async () => {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('imageUrlFor', 'banner');

      const result = await uploadUserImage(formData);

      if ('error' in result && result.error) {
        const message = 'message' in result.error ? result.error.message : 'Unknown error';
        setErrorMessage(message as string);
        setIsOpen(true);
      } else if ('data' in result) {
        setImgSrc(buildImageSrc(result.data.imgUrl, 'md'));
      }

    })();

  }, [file, uploadUserImage]);

  if (userId !== currentUserId) {
    return (
      <div className='h-full'>
        <img
          className={`object-cover w-full h-full  max-h-80 rounded-app-base`}
          src={imgSrc}
          alt=''
        />
      </div>
    );
  }

  return (
    <>
      <DialogComponent
        isOpen={isOpen}
        closeDialog={() => setIsOpen(false)}
        content={errorMessage ?? ''}
      />
      <div className='group h-full' onClick={changeImgHandler}>
        {
          isLoading
            ? <div className='flex h-full justify-center items-center'>
              <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
            </div>
            : <>
              <img
                className={`group-hover:opacity-40 object-cover w-full h-full  max-h-80 rounded-app-base cursor-pointer `}
                src={imgSrc}
                alt=''
              />
              <input 
                type='file' 
                ref={inputRef} 
                onChange={ev => setFile(ev.target.files?.[0] || null)} 
                className=' invisible'
              />
              <div className={`group-hover:visible absolute bottom-2 right-2 h-7 w-7 invisible cursor-pointer`}>
                <Icons variant={IconsVariants.EDIT} classes={`fill-white`} />
              </div>
            </>
        }

      </div>
    </>
  );
};